import { StorageClient } from './StorageClient';

export type GetStoredItemOptions = {
	useExpiredItem?: boolean;
};

export const DEFAULT_STORAGE_ENGINE = 'localStorage';
export default StorageClient;
export { StorageClient } from './StorageClient';
